import { ReactQueryV5 } from "@mindlercare/mindlerapi-client";
const { useMutation, useQuery, useQueryClient } = ReactQueryV5;
import { get, post } from "../services/httpClient";
import type { Passkey } from "./types";

const PASSKEYS_QUERY_KEY = ["passkeys"];

const getUserPasskeys = async () => {
  const res: { passkeys: Passkey[] } = await get("passkey/get-user-passkeys");
  return res.passkeys ?? [];
};

export const useGetUserPasskeys = () =>
  useQuery({ queryKey: PASSKEYS_QUERY_KEY, queryFn: getUserPasskeys });

const deletePasskey = (passkeyId: string): Promise<void> =>
  post("passkey/delete-user-passkey", { passkeyId });

export const useDeletePasskey = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deletePasskey,
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: PASSKEYS_QUERY_KEY }),
  });
};
